import React from 'react';
import { Check } from 'lucide-react';

const cx = (...classes) => classes.filter(Boolean).join(' ');

export function GenerationProgressView({
  stages = [],
  currentStep = 0,
  notice = null,
  ariaLabel = '생성 진행 상태',
}) {
  const stepCount = stages.length;
  const activeStep = Math.min(
    Math.max(Number(currentStep) || 0, 0),
    Math.max(stepCount - 1, 0),
  );
  const currentStage = stages[activeStep] || stages[0];
  const currentMessage = currentStage?.message || '';

  return (
    <div className="persona-generation-progress__content">
      {currentMessage ? <p>{currentMessage}</p> : null}
      <div className="persona-generation-progress__steps" aria-label={ariaLabel}>
        {stages.map((stage, index) => {
          const label = stage?.label || stage;
          const isComplete = index < activeStep;
          const isActive = index === activeStep;

          return (
            <div key={`${label}-${index}`} className="persona-generation-progress__stage">
              <div className="persona-generation-progress__stage-column">
                <div className="persona-generation-progress__indicator">
                  {isActive ? (
                    <span className="persona-generation-progress__ripple" aria-hidden="true" />
                  ) : null}
                  <span
                    className={cx(
                      'persona-generation-progress__marker',
                      isComplete && 'is-complete',
                      isActive && 'is-active',
                      !isComplete && !isActive && 'is-pending',
                    )}
                  >
                    {isComplete ? <Check size={12} strokeWidth={2.5} aria-hidden="true" /> : null}
                  </span>
                </div>
                <strong
                  className={cx(
                    'persona-generation-progress__label',
                    (isComplete || isActive) && 'is-highlighted',
                  )}
                >
                  {label}
                </strong>
              </div>
              {index < stepCount - 1 ? (
                <span className="persona-generation-progress__connector" aria-hidden="true" />
              ) : null}
            </div>
          );
        })}
      </div>
      {notice ? <div className="persona-generation-progress__hint">{notice}</div> : null}
    </div>
  );
}
